import { withRetryOn202 as retryOn202 } from '../retryOn202';

const TIMEOUT_MESSAGE = 'Max retries reached, connector result is not ready!';

/**
 * Legacy-connector wrapper over the shared 202-polling loop, keeping the
 * original single-argument signature and timeout message.
 */
export function withRetryOn202<T>(fetchFn: () => Promise<T>): Promise<T> {
    return retryOn202(fetchFn, { timeoutMessage: TIMEOUT_MESSAGE });
}
